<template>
  <footer class="dark:bg-black p-10 text-base-content relative">
    <div class="flex flex-col justify-between md:flex-row">
    <div class="">

      <svg width="50" height="50" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg"
        xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:ns1="http://sozi.baierouge.fr"
        xmlns:cc="http://web.resource.org/cc/" xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" id="Layer_1"
        enable-background="new -2.5 -2.5 365 185" xml:space="preserve" viewBox="-2.5 -2.5 365 185" version="1.1" y="0px"
        x="0px">

        <path
          d="m299.75 60.587c-4.108 0-8.123 0.411-12.001 1.188-11.95-35.875-46.03-61.775-86.23-61.775-33.761 0-63.196 18.27-78.847 45.363-0.919-0.036-1.84-0.07-2.769-0.07-23.494 0-44.202 11.816-56.409 29.777-3.263-0.617-6.627-0.953-10.071-0.953-29.503 0-53.42 23.702-53.42 52.943 0 29.24 23.917 52.94 53.421 52.94h66.435 0.045 0.045 81.525 0.045 0.047 98.145 0.046c33.28 0 60.25-26.73 60.25-59.71 0-32.972-26.97-59.703-60.25-59.703z"
          fill="#FFFFFF" />
        <path
          d="m299.75 182.5h-246.33c-30.834 0-55.92-24.87-55.92-55.44s25.086-55.441 55.922-55.441c2.96 0 5.957 0.241 8.931 0.716 13.225-18.527 34.616-29.541 57.549-29.541 0.458 0 0.914 0.008 1.369 0.02 16.79-27.991 47.39-45.314 80.25-45.314 39.618 0 74.665 24.595 87.896 61.431 3.41-0.561 6.878-0.844 10.34-0.844 34.599 0 62.747 27.905 62.747 62.206-0.01 34.3-28.16 62.21-62.76 62.21zm-246.33-105.88c-28.079 0-50.922 22.628-50.922 50.443s22.843 50.44 50.921 50.44h246.33c31.842 0 57.747-25.663 57.747-57.207 0-31.543-25.905-57.206-57.747-57.206-3.863 0-7.736 0.383-11.51 1.139l-2.165 0.434-0.698-2.095c-11.97-35.924-45.67-60.062-83.86-60.062-31.581 0-60.963 16.903-76.682 44.113l-0.754 1.306-1.507-0.059c-0.887-0.034-1.776-0.068-2.672-0.068-21.82 0-42.135 10.722-54.341 28.682l-0.921 1.355-1.611-0.304c-3.2-0.602-6.433-0.908-9.615-0.908z"
          fill="#231F20" />

      </svg>
      <p class="text-white">
        Cloudamai LLC
        <br />
      </p>
    </div>
    <div class = "relative">
      <p class="font-family: Georgia pt-9 text-white w-50"></p>
      <a href="https://aws.amazon.com/startups/showcase/startup-details/aa4f3f14-6622-4c3f-bc10-c1bdd86d2ca1?lang=en-US"><img class="text-white w-4/12 absolute md:right-0 md:w-3/4" src="/img/awslogo.png" alt="Your Logo"/></a>

    </div>
  </div>
          <CopyRight></CopyRight>
  </footer>
  <slot></slot>
</template>